<div
    class="full-modal-config__section"
    provideParentForm
>
    <h3>{{ l10nKeys.sectionTitleSctp | vtranslate }}</h3>
    <health-monitor-port-ip-group [editable]="editable"></health-monitor-port-ip-group>

    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.clientRequestHeaderInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="sctp-request"
                objectType="{{ objectTypes.HealthMonitorSctp }}"
                fieldName="sctp_request"
                [(ngModel)]="editable.config.sctp_monitor.config.sctp_request"
                placeholder="{{ l10nKeys.clientRequestHeaderInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.serverResponseDataInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="sctp-response"
                objectType="{{ objectTypes.HealthMonitorSctp }}"
                fieldName="sctp_response"
                [(ngModel)]="editable.config.sctp_monitor.config.sctp_response"
                placeholder="{{ l10nKeys.serverResponseDataInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
</div>
